<div class="details-container">
  <div class="flex-row mt-0 mr-10 ml-10 mb-20 content-end">
    <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close()" aria-label="Close">
      <img class="cursor-pointer" alt="Close" src="assets/new-images/icon-close.svg" aria-hidden="true">
    </button>
  </div>
  <div class="details overflow-hidden overflow-y pt-20 pb-20 pl-50 pr-50 pl-md-10 pr-md-10">
    <h5 class="mt-10 mr-0 ml-0 mb-20 fs-16 text-dark fw-7" *ngIf="data?.title">{{data?.title}}</h5>
    <div class="flex-row">
      <img class="border-radius-circle mr-15 width-4 height-4" [alt]="data?.user.name" *ngIf="!data?.user.profileImage"
        src="assets/new-images/user-avatar.svg" />
      <img class="border-radius-circle mr-15 width-4 height-4" *ngIf="data?.user.profileImage"
        src="{{ data?.advImgURL }}{{ data?.user.profileImage }}" [alt]="data?.user.name" />
      <div class="flex-row align-center content-between flex-1">
        <h3 class="fs-14 fw-6">{{data?.user.name}}</h3>
        <span class="fs-12 ml-20 text-secondary">{{data?.date | date:'dd MMM yyyy'}}</span>
      </div>
    </div>
    <div class="flex-row content-around mt-20 pt-20 pb-20 pr-40 pl-40 border-radius-6 pr-md-20 pl-md-20"
      *ngIf="data?.niftyPrice"
      [ngClass]="{'bg-success-light': data?.market === 'bullish', 'bg-danger-light': data?.market === 'bearish'}">
      <div class="mr-20 flex-row column content-between">
        <p class="mb-10 fs-12 text-secondary d-none d-block-md">NIFTY</p>
        <p class="mb-10 fs-14 text-secondary d-none-md">NIFTY {{preditionDate | date:'dd MMM yyyy'}}</p>
        <h4 class="flex-row align-center fs-18 text-dark fw-7 fs-md-16">{{data?.niftyPrice}}
          <p class="fs-14 text-secondary ml-10 fs-md-12" [ngClass]="{
          'text-success': calculateNiftyPrediction(data).isProfit,
          'text-danger': !calculateNiftyPrediction(data).isProfit
        }">
            {{ calculateNiftyPrediction(data).isProfit ? "+" : "-" }}
            {{
            calculateNiftyPrediction(data).profitLoss | number: "2.2-2"
            }}
            ({{ calculateNiftyPrediction(data).isProfit ? "+" : "-"
            }}{{
            calculateNiftyPrediction(data).percent | number: "2.2-2"
            }}%)
          </p>
        </h4>
      </div>
      <div class="mr-20 flex-row column content-between" *ngIf="data?.market === 'bullish'">
        <p class="mb-10 fs-14 text-secondary fs-md-12">MARKET</p>
        <div class="flex-row align-center" style="margin-top: 10px;">
          <img class="mr-10" src="assets/new-images/bull.svg" alt="Bullish">
          <p class="fs-14 text-secondary fs-md-12">Bullish</p>
        </div>
      </div>
      <div class="mr-20 flex-row column content-between" *ngIf="data?.market === 'bearish'">
        <p class="mb-10 fs-14 text-secondary fs-md-12">MARKET</p>
        <div class="flex-row align-center" style="margin-top: 10px;">
          <img class="mr-10" src="assets/new-images/bear.svg" alt="Bearish">
          <p class="fs-14 text-secondary fs-md-12">Bearish</p>
        </div>
      </div>
    </div>
    <div class="flex-row align-center content-center mt-30 pt-30 pb-30 pl-40 pr-40 border-radius-6"
      [ngClass]="{'bg-success-light': data?.market === 'bullish', 'bg-danger-light': data?.market === 'bearish'}"
      *ngIf="!data?.niftyPrice">
      <p class="mr-10 text-secondary fs-14 fs-md-12">MARKET</p>
      <div class="flex-row align-center" *ngIf="data?.market === 'bullish'">
        <img class="mr-10" src="assets/new-images/bull.svg" alt="Bullish">
        <p class="text-secondary fs-14 fs-md-12">Bullish</p>
      </div>
      <div class="flex-row align-center" *ngIf="data?.market === 'bearish'">
        <img class="mr-10" src="assets/new-images/bear.svg" alt="Bearish">
        <p class="text-secondary fs-14 fs-md-12">Bearish</p>
      </div>
    </div>
    <ng-container *ngIf="data?.video && !data?.desc">

      <div tabindex="0" role="button" class="videoPlayer mt-10 position-relative border-radius-6"
        (click)="playerClick('singleVideo',singleVideo);$event.stopPropagation();"
        (keydown.enter)="$any($event.currentTarget).click()"
        (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
        <!-- <vg-player class="max-height-30" (mouseover)="videoHover()" (mouseout)="videoHoverOut()">
          <vg-controls class="d-none"
            [ngClass]="{'showHide': playVideo.play && playVideo.id == 'singleVideo' && playVideo.showControl}">
            <vg-play-pause vgFor="singleVideo"></vg-play-pause>
            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

            <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>
            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
            <vg-mute></vg-mute>
            <vg-volume></vg-volume>

            <vg-fullscreen></vg-fullscreen>
          </vg-controls> -->
        <video #singleVideo id="singleVideo" preload="auto" aria-label="Prediction video">
          <source src="{{data?.baseUrl}}{{data?.video}}" type="video/mp4">
        </video>
        <!-- </vg-player> -->
        <button type="button"
          class="play flex-row tw-bg-transparent tw-border-0 tw-p-0 content-center position-absolute"
          (click)="playVideoNow('singleVideo', singleVideo);$event.stopPropagation();"
          [ngClass]="{'d-none': playVideo.play && playVideo.id === 'singleVideo'}" aria-label="Play video">
          <img class="cursor-pointer" src="assets/new-images/video-play.svg" alt="Video play" aria-hidden="true">
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!data?.video && data?.desc">
      <p class="mt-10 text-dark fs-14" style="line-height: 1.86;">{{data?.desc}}</p>
    </ng-container>
  </div>
</div>